import { writable } from 'svelte/store';

export const editState = writable([]);
export const foodEntries = writable([]);
export const sleepEntries = writable([]);